module.exports = __webpack_public_path__ + "static/img/023 3.267ad5d9.jpg";